// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/cxz6nkg.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Pretendard';
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

html, body {
  width: 100%;
  /* height: 100%; */
  @media only screen and (min-width: 1300px) {
    min-width: 1340px;
    min-height: 100vh;
  }
}

#root, .wrapper {
  width: 100%;
  position: relative;
}

.active {
  color: #DC140A !important;
}

/* .active div:first-child > span {
  color: #DC140A !important;
} */

@media only screen and (max-width: 1299px) {
  html, body {
    -ms-overflow-style: none;
    overflow-x: hidden;
    max-width: 100%;
    min-width: 360px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');\n@import url('https://use.typekit.net/cxz6nkg.css');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,900&display=swap');\n\n* {\n  font-family: 'Pretendard';\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n}\n\nhtml, body {\n  width: 100%;\n  /* height: 100%; */\n  @media only screen and (min-width: 1300px) {\n    min-width: 1340px;\n    min-height: 100vh;\n  }\n}\n\n#root, .wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.active {\n  color: #DC140A !important;\n}\n\n/* .active div:first-child > span {\n  color: #DC140A !important;\n} */\n\n@media only screen and (max-width: 1299px) {\n  html, body {\n    -ms-overflow-style: none;\n    overflow-x: hidden;\n    max-width: 100%;\n    min-width: 360px;\n  }\n  ::-webkit-scrollbar {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
